import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { firstValueFrom, Observable } from "rxjs";
import { take } from "rxjs/operators";
import { SideNavState } from "../../side-nav/state/side-nav/side-nav.reducer";
import { selectSideNavState } from "../../side-nav/state/side-nav/side-nav.selectors";
import { SetExpanded } from "../../side-nav/state/side-nav/side-nav.actions";

@Component({
  selector: "app-nav-toggler",
  templateUrl: "./nav-toggler.component.html",
  styleUrls: ["./nav-toggler.component.scss"],
  standalone: false,
})
export class NavTogglerComponent implements OnInit {
  sideNav$: Observable<SideNavState> = this.store.select(selectSideNavState);

  constructor(private store: Store<any>) {}

  ngOnInit() {}

  async toggleNav() {
    const sideNavSnapshot = await firstValueFrom(this.sideNav$.pipe(take(1)));
    this.store.dispatch(new SetExpanded(!sideNavSnapshot.expanded));
  }
}
